<div class="uninstall-donation-modal-container">
    <div id="uninstall-donation-modal">
        <div class="modal-header">
            <h5 class="modal-title" [translate]="'uninstall.support_further_development'"></h5>
            <button-control
                buttonClass="close"
                buttonType="button"
                [attr.aria-label]="'close' | translate"
                [buttonText]="'common.close'"
                (onClick)="close()">
                <span aria-hidden="true">&times;</span>
            </button-control>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-12">
                    <paypal-donation-control></paypal-donation-control>
                </div>
            </div>
            <br />
            <h3 [translate]="'uninstall.other_support'"></h3>
            <br />
            <div class="row">
                <div class="col-lg-12">
                    <support-buttons-control></support-buttons-control>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button-control
                themeColor="secondary"
                buttonType="button"
                [buttonText]="'common.close'"
                (onClick)="close()">
            </button-control>
        </div>
    </div>
</div>
